let current = null;
export function phoneStatus() {
  return current;
}
export function setPhoneStatus(status) {
  current = status;
}